var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 2.19746C11.6143 2.10834 11.5041 2.03766 11.3827 1.98947C11.2614 1.94128 11.1313 1.91654 11 1.91667H6C5.86867 1.91654 5.7386 1.94128 5.61727 1.98947C5.49594 2.03766 5.38574 2.10834 5.293 2.19746L2.293 5.07246C2.19996 5.16131 2.12617 5.26691 2.07589 5.38319C2.0256 5.49947 1.99981 5.62413 2 5.75001V10.5417C2 10.7966 2.105 11.04 2.293 11.2192L12.293 20.8025C12.3857 20.8919 12.4958 20.9627 12.6171 21.0111C12.7385 21.0594 12.8686 21.0843 13 21.0843C13.1314 21.0843 13.2615 21.0594 13.3829 21.0111C13.5042 20.9627 13.6143 20.8919 13.707 20.8025L21.707 13.1359C21.7999 13.047 21.8737 12.9413 21.924 12.8251C21.9743 12.7088 22.0002 12.5842 22.0002 12.4583C22.0002 12.3325 21.9743 12.2079 21.924 12.0916C21.8737 11.9753 21.7999 11.8697 21.707 11.7808L11.707 2.19746V2.19746ZM13 18.7699L4 10.1449V6.14676L6.414 3.83334H10.586L19.586 12.4583L13 18.7699Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35305 9.58334C9.26267 9.58334 10.0001 8.87668 10.0001 8.00496C10.0001 7.13325 9.26267 6.42659 8.35305 6.42659C7.44344 6.42659 6.70605 7.13325 6.70605 8.00496C6.70605 8.87668 7.44344 9.58334 8.35305 9.58334Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag2);
export default __webpack_public_path__ + "static/media/tag2.a3500621c7f410cd2cbd681da4e29447.svg";
export { ForwardRef as ReactComponent };